import { render, staticRenderFns } from "./EcocarotidiViewComponent.vue?vue&type=template&id=0a93afcc"
import script from "./EcocarotidiViewComponent.vue?vue&type=script&lang=js"
export * from "./EcocarotidiViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports